"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcRegisterSelector = exports.UcRegisterEntryMiniCard = exports.UcSuggestRegisterEntryOption = void 0;
const UcSuggestRegisterEntryOption_yaml_component_1 = __importDefault(require("./UcSuggestRegisterEntryOption.yaml?component"));
exports.UcSuggestRegisterEntryOption = UcSuggestRegisterEntryOption_yaml_component_1.default;
const UcRegisterEntryMiniCard_yaml_component_1 = __importDefault(require("./UcRegisterEntryMiniCard.yaml?component"));
exports.UcRegisterEntryMiniCard = UcRegisterEntryMiniCard_yaml_component_1.default;
const UcRegisterSelector_yaml_component_1 = __importDefault(require("./UcRegisterSelector.yaml?component"));
exports.UcRegisterSelector = UcRegisterSelector_yaml_component_1.default;
